export default __webpack_public_path__ + "static/media/alertSettings.77e504b9.svg";